/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { OperationStatus } from "Constants/OperationStatus";
import { AppState } from "Dataflows/Reducers";
import { IUserProfileComment } from "Interfaces/UserProfile/IUserProfileComment";

/**
 * Returns user profile comments.
 * @param appState
 */
export const getComments = (state: AppState): IUserProfileComment[] =>
  state.mvpState.commentsState.userProfileComments;

/**
 * Returns loading status of user profile comments.
 * @param appState
 * @returns {boolean}
 */
export const getCommentsIsLoadingStatus = (state: AppState): boolean =>
  state.mvpState.commentsState.commentsOperationStatus?.read === OperationStatus.Pending;

/**
 * Returns loading status of user profile comments.
 * @param appState
 * @returns {boolean}
 */
export const getAddCommentOperationStatus = (state: AppState): OperationStatus | undefined =>
  state.mvpState.commentsState.commentsOperationStatus?.create;

/**
 * Returns error message returned when user profile comments fails.
 * @param appState
 * @returns {string}
 */
export const getCommentsErrorMessage = (state: AppState): string =>
  state.mvpState.commentsState.commentsOperationStatus?.read === OperationStatus.Failed &&
  !!state.mvpState.commentsState.commentsErrorMessage
    ? state.mvpState.commentsState.commentsErrorMessage
    : "";
